import { useSyncExternalStore } from "react";

let isOpen = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return isOpen;
}

function toggle() {
  isOpen = !isOpen;
  for (const listener of listeners) listener();
}

function close() {
  if (!isOpen) return;
  isOpen = false;
  for (const listener of listeners) listener();
}

// Register keyboard shortcut once globally, outside React lifecycle
document.addEventListener("keydown", (e: KeyboardEvent) => {
  if ((e.metaKey || e.ctrlKey) && e.key === "k") {
    e.preventDefault();
    toggle();
  }
});

export function useCommandBar() {
  const open = useSyncExternalStore(subscribe, getSnapshot);
  return { open, toggle, close };
}
